import { IconType } from "react-icons";
import {
  SiReact,
  SiTypescript,
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiPython,
  SiNodedotjs,
  SiFlask,
  SiRedux,
  SiDotnet,
  SiReactquery,
  SiAngular,
  SiAmazonwebservices,
  SiPostgresql,
  SiAntdesign,
  SiDocker,
  SiKubernetes,
} from "react-icons/si";
import {
  Email as EmailIcon,
  GitHub as GitHubIcon,
  LinkedIn as LinkedInIcon,
} from "@mui/icons-material";

export type TSkill = {
  name: string;
  color: string;
  icon: IconType;
};

export type TAbout = {
  name: String;
  content: String;
  title: string;
  description: string;
  techinalSkillsTitle: string;
  skill: TSkill[];
};

interface SocialLink {
  name: string;
  icon: React.ReactNode;
  url: string;
}

export const about: TAbout = {
  name: "Hi 👋🏻 I’m Duygu, a Web Developer",
  content:
    "Welcome to my portfolio website. Thank you for visiting, and I hope you enjoy exploring my portfolio.",
  title: "About Me",
  description:
    "Experienced software engineer for 7 years, with a background in development, deployment, maintenance, and performance optimization, prioritizing high-quality software delivery . Seeking a role to build high-performance, responsive, scalable applications while staying current with new technologies and best practices. Committed to continuous improvement.",
  techinalSkillsTitle: "Technical Skills",
  skill: [
    { name: "JavaScript", icon: SiJavascript, color: "#F7DF1E" },
    { name: "TypeScript", icon: SiTypescript, color: "#3178C6" },
    { name: "React", icon: SiReact, color: "#61DAFB" },
    { name: "Redux", icon: SiRedux, color: "#764abc" },
    { name: "HTML5", icon: SiHtml5, color: "#E34F26" },
    { name: "CSS3", icon: SiCss3, color: "#1572B6" },
    { name: "Reactquery", icon: SiReactquery, color: "#FF495C" },
    { name: "Angular", icon: SiAngular, color: "#C51336" },
    { name: "Dotnet", icon: SiDotnet, color: "#6D277E" },
    { name: "Amazonwebservices", icon: SiAmazonwebservices, color: "#FE9C15" },
    { name: "Postgresql", icon: SiPostgresql, color: "#477FA4" },
    { name: "Python", icon: SiPython, color: "#3776AB" },
    { name: "Node.js", icon: SiNodedotjs, color: "#339933" },
    { name: "Flask", icon: SiFlask, color: "#000000" },
    { name: "Ant Design", icon: SiAntdesign, color: "#0170FE" },
    { name: "Docker", icon: SiDocker, color: "#2496ED" },
    { name: "Kubernetes", icon: SiKubernetes, color: "#326CE5" },
  ],
};

export const socialLinks: SocialLink[] = [
  {
    name: "GitHub",
    icon: <GitHubIcon />,
    url: "https://github.com/duyguevrim",
  },
  {
    name: "LinkedIn",
    icon: <LinkedInIcon />,
    url: "https://linkedin.com/in/duyguevrimodabas",
  },
  {
    name: "Email",
    icon: <EmailIcon />,
    url: "mailto:duyguevrimodabass@gmail.com",
  },
];

export default about;
